import React from 'react';
import Header from '../../components/Header.tsx';
import Footer from '../../components/Footer.tsx';
import './NotFound.css';
import { Typography } from '@mui/material';

const notfound = require('../../assets/img/404.png')
const NotFound = () => {
    return (
        <div>
            <Header />
            <Typography className='titleNotFount'>Oops!</Typography>
            <Typography className='subtitleNotFound'>PAGINA NO ENCONTRADA</Typography>
            <Typography className='text404'>404</Typography>
            <img
                        src={notfound} /* Ruta de tu imagen de 40x40 */
                        alt="notfund"
                        className="notfound"
                      />
            <Footer />
        </div>
    );
};

export default NotFound;
